import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
    allInquiries: [],
    allInquiriesLoading: false,
    fields: {
      ALL_INQUIRIES: `
        id
        created_at
        status
        agent  {
          full_name
        }
        customer {
          id
          company_name
        }
        _rowVariant
      `
    }
  };
};

const state = getDefaultState();

const getters = {
  getAllInquiries(state) {
    return state.allInquiries;
  },
  getAllInquiriesLoading(state) {
    return state.allInquiriesLoading;
  }
};

const actions = {
  fetchAllInquiries({ commit, dispatch, state }, payload) {
    commit("setAllInquiriesLoading", true);

    const data = {
      query: `
        query {
          allInquiries(
            limit: 20,
            year: "${payload.year}",
            source: "${payload.source}"
          ) { ${state.fields.ALL_INQUIRIES} }
        }
      `
    };
    const data_1 = {
      query: `
        query {
          allInquiries(
            offset: 20,
            year: "${payload.year}",
            source: "${payload.source}"
          ) { ${state.fields.ALL_INQUIRIES} }
        }
      `
    };

    dispatch("fetchInquiries", {
      data: data,
      commit_to: "setAllInquiries"
    }).then(() => {
      dispatch("fetchInquiries", {
        data: data_1,
        commit_to: "setAddToAllInquiries"
      }).then(() => {
        commit("setAllInquiriesLoading", false);
      });
    });
  },
  fetchInquiries({ commit, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            commit(payload.commit_to, res.data.data.allInquiries);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        })
        .then(() => {
          resolve();
        });
    });
  },
  saveNewInquiry({ commit, rootGetters }, payload) {
    commit("setShowLoadingModal", true, { root: true });
    let data = {
      query: `
        mutation InquiryCreate($inquiry: InquiryInput) {
          res: InquiryCreate (inquiry: $inquiry) { id }
        }
      `,
      variables: {
        inquiry: payload.newInquiryData
      }
    };

    axios
      .post(rootGetters.getGraphQlUrl, data, rootGetters.getDefConf)
      .then(res => {
        if (res.data.errors !== undefined && res.data.errors.length > 0) {
          alert(res.data.errors[0].message);
        } else {
          router.push({
            name: "inquiry",
            params: {
              id: parseInt(res.data.data.res.id)
            }
          });
        }
      })
      .catch(err => {
        alert(err);
        console.error(err);
      })
      .then(() => {
        commit("setShowLoadingModal", false, { root: true });
      });
  }
};

const mutations = {
  setAllInquiries(state, inquiries) {
    state.allInquiries = inquiries;
  },
  setAddToAllInquiries(state, inquiries) {
    state.allInquiries.push(...inquiries);
  },
  setAllInquiriesLoading(state, loading) {
    state.allInquiriesLoading = loading;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
